import { useContext } from 'react'

import { BadgeContext } from '../providers/BadgeProvider/BadgeProvider'

export const useBadgeContext = () => {
  const badgeContext = useContext(BadgeContext)

  if (badgeContext === undefined) {
    throw new Error('badgeContext must be used within a BadgeProvider')
  }

  return badgeContext
}
